@import "../../variables.scss";

.readingList {
  @media (max-width: $size-md) {
    order: 1;
  }
}

.readingList__wrapper {
  width: 48%;
  @media (max-width: $size-md) {
    width: 100%;
    box-shadow: none !important;
  }
}

.readingList__wrapperGB {
  width: 100%;
  @media (max-width: $size-md) {
    box-shadow: none !important;
  }
}
